import { createContext, useContext } from 'react';

import { AuthContext } from './AuthContext';
import NotificationsApi from '../api/NotificationsApi';
import usePolledResource from '../util/usePolledResource';
import { DISABLE_NOTIFICATION_POLLING } from '../constants';

const POLLING_INTERVAL = 1000 * 30;

export const NotificationsContext = createContext({
  notifications: [],
});

export function NotificationsProvider({ children }) {
  const auth = useContext(AuthContext);
  const user = auth?.user?.user;
  const enabled = !!user && !DISABLE_NOTIFICATION_POLLING;

  const [notifications] = usePolledResource({
    resourceFn: () => (enabled ? NotificationsApi.list() : Promise.resolve([])),
    dependencies: [user],
    interval: POLLING_INTERVAL,
    initialValue: [],
    enabled,
  });

  return (
    <NotificationsContext.Provider value={{ notifications }}>
      {children}
    </NotificationsContext.Provider>
  );
}
